import type { ConsentConfig } from '../types/consent';

/**
 * 동의 관련 설정 상수
 */

export const DEFAULT_CONSENT_CONFIG: ConsentConfig = {
  title: '마이크 사용 동의',
  description: '음성 대화를 위해 마이크 접근 권한이 필요합니다. 마이크를 사용하시겠습니까?',
  confirmButtonText: '시작하기',
  declineButtonText: '채팅으로 계속',
  allowDecline: true,
};

export const CONSENT_STORAGE_KEY = 'voice_consent_granted';

export const CONSENT_BEHAVIOR = {
  // 동의 기록 저장 여부
  PERSIST_CONSENT: false,
  // 동의 후 자동으로 음성 모드 시작
  AUTO_START_VOICE_ON_CONSENT: true,
  // 거부 시 채팅 모드로 자동 전환
  SWITCH_TO_CHAT_ON_DECLINE: true,
  // 디버그 로깅
  ENABLE_LOGGING: true,
  // 초기 마운트 시 모달 표시 여부
  SHOW_ON_MOUNT: true,
} as const;

export const CONSENT_MESSAGES = {
  GRANTED: '마이크 사용 동의 완료',
  DECLINED: '채팅 모드로 진행합니다',
  ALREADY_GRANTED: '이미 동의가 완료되었습니다',
} as const;
